import React, {useState} from "react";
import Modal from "../../../../../components/modal/Modal";
import ModalTitle from "../../../../../components/modal/ModalTitle";
import "./projectExportErrorsModal.scss";
import ModalButtons from "../../../../../components/modal/ModalButtons";
import Button from "../../../../../components/ui/Button";
import {ProjectSource, SyncMode} from "../../../../../models/enums";
import "./projectExportConfirmationModal.scss";
import {useTranslation} from "react-i18next";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

interface ProjectExportConfirmationModalProps {
	projectSource: ProjectSource,
	onSubmit: (syncMode: SyncMode) => void,
	onClose: () => void,
	isSyncOptionsModelLoading: boolean;
}

const ProjectExportConfirmationModal: React.FC<ProjectExportConfirmationModalProps> = ({
	projectSource,
	onSubmit,
	onClose,
	isSyncOptionsModelLoading
}) => {
	const {t} = useTranslation();
	const [syncMode, setSyncMode] = useState<SyncMode>(SyncMode.REPLACE);

	const translations = {
		"title": {
			[ProjectSource.QUOTE]: isSyncOptionsModelLoading ? t(`projects.summary.confirmationModal.quote.syncOptionsTitle`) : t(`projects.summary.confirmationModal.quote.title`),
			[ProjectSource.JOB]: isSyncOptionsModelLoading ? t(`projects.summary.confirmationModal.job.syncOptionsTitle`) : t(`projects.summary.confirmationModal.quote.title`)
		},
		"contentLine1": {
			[ProjectSource.QUOTE]: isSyncOptionsModelLoading ? t(`projects.summary.confirmationModal.quote.syncOptionsAlertLine1`) : t(`projects.summary.confirmationModal.quote.contentLine1`),
			[ProjectSource.JOB]: isSyncOptionsModelLoading ? t(`projects.summary.confirmationModal.job.syncOptionsAlertLine1`) : t(`projects.summary.confirmationModal.job.contentLine1`)
		},
		"contentLine2": {
			[ProjectSource.QUOTE]: isSyncOptionsModelLoading ? t(`projects.summary.confirmationModal.quote.syncOptionsAlertLine2`) : t(`projects.summary.confirmationModal.quote.contentLine2`),
			[ProjectSource.JOB]: isSyncOptionsModelLoading ? t(`projects.summary.confirmationModal.job.syncOptionsAlertLine2`) : t(`projects.summary.confirmationModal.job.contentLine2`)
		},
		"cancelButtonLabel": isSyncOptionsModelLoading ? t("common.buttons.cancel") : t("common.buttons.no"),
		"proceedButtonLabel": isSyncOptionsModelLoading ? t("common.buttons.syncAnyway") : t("common.buttons.yes")
	}

	const contentLine2 = !isSyncOptionsModelLoading && syncMode === SyncMode.APPEND
		? t("projects.summary.confirmationModal.syncMode.appendInfo")
		: translations.contentLine2[projectSource];

	return (
		<Modal isOpen={true} onClose={onClose} customClass="project-export-confirmation-modal">
			<ModalTitle>
				{translations.title[projectSource]}
			</ModalTitle>
			<div className="project-export-confirmation-modal_content">
				{translations.contentLine1[projectSource]}
			</div>
			<div className="project-export-confirmation-modal_content project-export-confirmation-modal_content--line2">
				{contentLine2}
			</div>
			{!isSyncOptionsModelLoading && (
				<FormControl>
					<RadioGroup
						value={syncMode}
						onChange={(e) => setSyncMode(e.target.value as SyncMode)}
					>
						<FormControlLabel
							value={SyncMode.REPLACE}
							control={<Radio />}
							label={t("projects.summary.confirmationModal.syncMode.replaceLabel")}
						/>
						<FormControlLabel
							value={SyncMode.APPEND}
							control={<Radio />}
							label={t("projects.summary.confirmationModal.syncMode.appendLabel")}
						/>
					</RadioGroup>
				</FormControl>
			)}
			<ModalButtons>
				<Button label={translations.cancelButtonLabel} variant={"optional"} onClick={onClose}/>
				<Button label={translations.proceedButtonLabel} variant={"primary"} onClick={() => onSubmit(syncMode)}/>
			</ModalButtons>
		</Modal>
	);
};

export default ProjectExportConfirmationModal;
